function maximumFourDigits(message) {
    return (value) => {
        var _a;
        if (value === null || value === undefined || value === '') {
            return;
        }
        const digitCount = ((_a = value.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.length) || 0;
        if (digitCount > 4) {
            throw new Error(message);
        }
    };
}
export default maximumFourDigits;
